import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
interface HeroProps {
  onCTAClick: () => void;
}
export function Hero({
  onCTAClick
}: HeroProps) {
  return <section className="relative w-full overflow-hidden bg-cream py-16 md:py-24" data-id="element-123">
      {/* Soft pastel decorative blobs */}
      <div className="pointer-events-none absolute -top-24 -left-24 w-80 h-80 rounded-full bg-blush opacity-50 blur-3xl" aria-hidden="true" data-id="element-124" />
      <div className="pointer-events-none absolute top-1/3 -right-24 w-96 h-96 rounded-full bg-sage opacity-50 blur-3xl" aria-hidden="true" data-id="element-125" />
      <div className="pointer-events-none absolute -bottom-32 left-1/3 w-80 h-80 rounded-full bg-sky-pastel opacity-50 blur-3xl" aria-hidden="true" data-id="element-126" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-8" data-id="element-127">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-128">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-129">
            <span className="inline-flex items-center gap-2 bg-blush-soft text-blush-ink text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6" data-id="element-130">
              <SparklesIcon className="w-3.5 h-3.5" data-id="element-131" />
              El Detox Invisible
            </span>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-tight mb-6" data-id="element-132">
              Por qué el "Estilo de Vida Saludable" está saboteando tu
              fertilidad
              <span className="block text-sage-deep mt-2" data-id="element-133">
                (y cómo resetearlo en 14 días)
              </span>
            </h1>
            <p className="text-lg md:text-xl text-ink-soft mb-8 leading-relaxed" data-id="element-134">
              El protocolo práctico para eliminar los disruptores endocrinos
              invisibles en tu hogar que bloquean tus hormonas y te impiden
              concebir.
            </p>
            <motion.button onClick={onCTAClick} className="inline-flex items-center gap-2 bg-sage-deep text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg" whileHover={{
            y: -2,
            boxShadow: '0 14px 34px rgba(148, 181, 142, 0.45)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-135">
              DESCARGAR AQUÍ
              <span aria-hidden="true" data-id="element-136">→</span>
            </motion.button>
            <p className="text-sm text-ink-muted mt-4" data-id="element-137">
              Para parejas en EE.UU. buscando respuestas reales
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: 0.2
        }} className="relative" data-id="element-138">
            <div className="absolute -inset-4 bg-white/40 rounded-3xl blur-2xl" aria-hidden="true" data-id="element-139" />
            <img src="https://cdn.magicpatterns.com/uploads/fV7KR41b8GeviY8My2CSqg/fertilidad_producto_imagen_organica.png" alt="El Detox Invisible - Guía para tu fertilidad mostrando versiones para mujer y hombre en laptop con fondo natural" className="relative w-full h-auto rounded-2xl shadow-2xl" data-id="element-140" />
          </motion.div>
        </div>
      </div>
    </section>;
}